import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Button } from 'antd'

import NextButton from '../../common/NextButton'
import css from '../../common/Form.css'
import BusinessForm from './BusinessForm'

const Practice = ({
  businessArrayId,
  businesses,
  createOrUpdateBusiness,
  editBusiness,
  editingBusiness,
  externalId,
  handleNamedInputChange,
  isBusinessFormOpen,
  isTopsAdmin,
  onNext,
  practiceName,
  toggleBusinessForm,
}) => {
  const renderBusiness = (business, index) => (
    <li key={business.id || `business-${index}`} className={css.item}>
      <p>
        <Button
          className={css.smallButton}
          icon="edit"
          size="small"
          style={{padding: '0 12px 0 0'}}
          onClick={() => editBusiness(business, index)}
        />
        <span>{business.name}</span>
      </p>
      <span>{business.website}</span>
      <span>{business.registration_type}</span>
      <span>{business.registration_identifier}</span>
      <span>{business.registration_number}</span>
    </li>
  )

  const businessElems = businesses.map((bus, idx) => renderBusiness(bus, idx))

  return (
    <React.Fragment>
      <Form
        layout="horizontal"
        onSubmit={e => {
          e.preventDefault()
          onNext()
        }}
      >
        {isTopsAdmin && (
          <Form.Item label="Practice Id" className={css.label}>
            <Input
              placeholder="e.g. 21"
              value={externalId}
              onChange={handleNamedInputChange}
              className={css.input}
              name="externalId"
            />
          </Form.Item>
        )}
        <Form.Item label="Practice Name" className={css.label}>
          <Input
            placeholder="e.g. XYZ Orthodontics"
            value={practiceName}
            onChange={handleNamedInputChange}
            className={css.input}
            name="practiceName"
          />
        </Form.Item>
        <Form.Item>
          <NextButton isSubmit isDisabled={!practiceName} />
        </Form.Item>
      </Form>
      <h3>Tax-related info necessary for RG messaging services:</h3>
      <div className={css.container}>
        <div className={css.section}>
          <ul className={css.list}>
            {businessElems}
            {isBusinessFormOpen ? (
              <BusinessForm
                addOrEdit={createOrUpdateBusiness}
                business={editingBusiness}
                businessArrayId={businessArrayId}
                hideForm={toggleBusinessForm}
              />
            ) : (
              <Button
                onClick={toggleBusinessForm}
                className={css.addButton}
                icon="plus"
              >
                Add Business
              </Button>
            )}
          </ul>
        </div>
      </div>
    </React.Fragment>
  )
}


Practice.propTypes = {
  businessArrayId: PropTypes.number,
  businesses: PropTypes.arrayOf(PropTypes.object),
  createOrUpdateBusiness: PropTypes.func.isRequired,
  editBusiness: PropTypes.func.isRequired,
  editingBusiness: PropTypes.object,
  externalId: PropTypes.string,
  handleNamedInputChange: PropTypes.func.isRequired,
  isBusinessFormOpen: PropTypes.bool.isRequired,
  isTopsAdmin: PropTypes.bool.isRequired,
  onNext: PropTypes.func.isRequired,
  practiceName: PropTypes.string,
  toggleBusinessForm: PropTypes.func.isRequired,
}

Practice.defaultProps = {
  businesses: [],
  externalId: '',
  isBusinessFormOpen: false,
  practiceName: '',
}

export default Practice



// WEBPACK FOOTER //
// ./src/AddPractice/Practice/index.js